import React from "react";
import {
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Text,
	Link,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";

const TheContextPaperAndPlastic: React.FC = () => (
	<>
		{/* members */}
		<Flex
			as="section"
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height={{ xs: "450px", sm: "300px" }}
			minH={{ xs: "450px", sm: "300px" }}
			maxH="450px"
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/jpg/blogBanner.jpg"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				display="flex"
				as="section"
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDir={{ xs: "column", md: "row" }}
				columnGap="24px"
				rowGap="30px"
				alignItems={{ xs: "flex-start", md: "flex-start" }}
				px={{ xs: "14px", sm: "28px", md: "45px", lg: "60px", xl: "inherit" }}
			>
				<Flex flexDir="column" rowGap="16px">
					<Heading
						color="white"
						fontSize={{ xs: "36px", sm: "42px", lg: "64px" }}
						fontWeight="800"
						lineHeight={{ xs: "35px", lg: "83px" }}
					>
						#TheContext
					</Heading>
					{/* <Heading
            color="white"
            fontSize={{ xs: '28px', sm: '34px' }}
            fontWeight="500"
            lineHeight="32px"
          >
            - By IVCA
          </Heading> */}
				</Flex>
				<Box
					w="1.5px"
					h={{ md: "200px", lg: "300px", xl: "230px" }}
					bgColor="white"
					display={{ xs: "none", md: "block" }}
				/>
				<Box
					w={{ xs: "70%", sm: "60%" }}
					h="1.5px"
					bgColor="white"
					display={{ xs: "block", md: "none" }}
				/>
				<Flex flexDir="column" rowGap="8px">
					<Heading
						as="h1"
						mb={{ xs: "10px", md: "20px" }}
						variant="reportCardTitle"
						fontSize={{ xs: "27px", sm: "29px", md: "32px", lg: "54px" }}
						color="white"
						lineHeight={{ xs: "36px", sm: "40px", md: "46px", lg: "70.2px" }}
					>
						The Paper AND Plastic Moment for Indian Startups
					</Heading>
					<Text
						fontSize={{ xs: "18px", sm: "18px", md: "20px", lg: "22px" }}
						fontWeight="600"
						color="white"
						lineHeight="28px"
					>
						Mohanjit Jolly
					</Text>
				</Flex>
			</Container>
		</Flex>
		<Container
			as="section"
			maxW="container.xl"
			pb="80px"
			pt="40px"
			minH="420px"
			display={{ xs: "flex", md: "inherit" }}
			flexDirection="column"
		>
			{/* <Box as="main" w="100%" pb="40px">
        <Text variant="blogAnswer">
          Welcome to our ‘Fund in Focus’ series where we profile our member
          funds, underscore their investment philosophy, and highlight some of
          their interesting work. Today we speak to{' '}
          <Link
            href="https://www.linkedin.com/in/mjolly/"
            target="_blank"
            style={{
              textDecoration: 'underline',
            }}
            rel="noreferrer"
          >
            Mohanjit Jolly
          </Link>
          , Partner,{' '}
          <Link
            href="https://ironpillarfund.com/"
            target="_blank"
            style={{
              textDecoration: 'underline',
            }}
            rel="noreferrer"
          >
            Iron Pillar
          </Link>
          . In this feature he shares the venture fund’s vision to back high
          value start-ups who are “building from India for the world”, the close
          of its $129Mn cloud fund, top investment trends and the fund’s bullish
          approach towards investing in enterprise centric sectors in 2023.
        </Text>
      </Box> */}

			<Img
				src="https://static.levocdn.com/WGLBUT82/mohanjit_2-7163425434255360811.jpeg"
				alt="Mohanjit Jolly"
				width="300px"
				float={{ xs: "right", md: "left" }}
				alignSelf={{ xs: "center", md: "flex-start" }}
				mx={{ xs: "0px", md: "0px" }}
				mr={{ xs: "0px", md: "40px", lg: "60px", xl: "70px" }}
				mb="20px"
				objectFit="contain"
			/>
			<Box>
				<Link
					display="flex"
					alignItems="center"
					href="https://www.linkedin.com/in/mjolly/"
					target="_blank"
				>
					<IconButton
						aria-label="linkedin"
						icon={<FaLinkedin size="28px" color="rgba(100, 100, 140, 0.6)" />}
						variant="unstyled"
						cursor="pointer"
					/>
					<Heading
						fontWeight="800"
						variant="blogQuestion"
						fontSize="20px"
						opacity="0.8"
					>
						Mohanjit Jolly
					</Heading>
				</Link>
				<Box
					ml={{ xs: "auto", md: "345px", lg: "370px" }}
					mr={{ xs: "auto", md: "0px" }}
					width={{ xs: "160px", md: "80px" }}
					h="2px"
					bgColor="primary.500"
					borderRadius="5px"
					mt={{ xs: "16px", md: "10px" }}
					mb="15px"
				/>
				<Box mt="16px" mb="20px">
					<Text variant="blogAnswer">
						There was a time not too long ago when, at a grocery store (at least
						in the U.S.), one would be asked if they wanted the produce packed
						in “paper or plastic” bags. The startups have gone through their
						‘paper or plastic’ moment as well. I am using that as a tongue in
						cheek analogy for startups with ‘paper’ and ‘plastic’ representing
						‘growth’ and ‘profitability’, respectively.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" pt="8px">
						There was a time when startups had to choose between growth and
						profitability. The fact that the world has gone through a massive
						shock of Covid-19 is the understatement of the century. The K shaped
						recovery with massive global stimuli and near zero interest rates
						fueled an unprecedented economic growth, mega rounds and unicorn
						creation unlike anything in the past (except perhaps the craziness
						of the dot com era). Most startups, flush with cash, selected or
						were mandated to chase growth over profitability. The latter was
						considered a four-letter word. That party came to an end in 2022 and
						the hangover effects continued through 2023 and into this year. The
						world of startups has had to transition from a “growth at any cost”
						to “capital efficient growth” to now “profitable growth” … what I
						refer to as the “paper AND plastic” era.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" mt="16px" mb="8px">
						Back in 2021, entrepreneurs were being told, top line is all that
						mattered, and some very large global investors (who shall remain
						nameless) flooded the market with term sheets (often within 24 hours
						of meeting the entrepreneur) at lofty valuations and celebrating the
						fact that they were looking at closing at least one investment per
						week. Competition was stiff among startups and separating from the
						pack was paramount, no matter what the unit economics. Or as one
						entrepreneur told me back then “what unit economics!?”
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" py="16px">
						Enter 2023 and now 2024…entrepreneurs have to face the reality of a
						cautious investment environment and the same investors who were
						pushing companies to grow at any cost, are now giving them whiplash
						by having them slow the growth and focus on that four letter word –
						profitability (ok, so not quite a four letter word☺). The frequency
						and amplitude of these changes are difficult for startups to cope
						with. But like it or not, that is the reality today.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" py="16px">
						Same entrepreneurs who were having trouble hiring just 12-18 months
						ago, now have to let people go, motivate their go-forward teams and
						improve productivity and efficiency. Enter AI and the ChatGPT
						movement! I am not sure if it is by design or coincidence that the
						downturn in overall funding environment seems to have coincided with
						the arrival of ChatGPT (at least at scale). I guess when one door
						closes, another technology door seems to open. While there has been
						and will continue to be some collateral startup damage through the
						’23 and ’24 funding downturn, there are those at the forefront, who
						have leveraged the benefits of Generative AI to be able to do more
						with less, in terms of people and capital. Those efficiencies will
						definitely pay dividends downstream.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" py="16px">
						What has been fascinating to me is the change in the startup lingo
						between 2021 and late 2022/2023. I had never in my 20+ years of
						working with startups heard the phrase “we are revenue positive”. I
						had to ask the entrepreneur to repeat the phrase to make sure I
						heard it correctly. In my head I wondered if there was such a thing
						as “revenue negative”. It almost seemed that entrepreneurs were
						afraid of turning EBITDA positive, as they felt (in a strange way)
						that they might be valued all of a sudden at multiples of EBITDA
						rather than revenue or Annual Recurring Revenue (ARR). Hence there
						was almost a forcing function to grow the top line while making sure
						the company would stay in the deep red. And by the way, the entire
						definition of “revenue” became confusing as companies shifted to ARR
						and Contracted ARR (CARR), which was basically the hypothetical
						ceiling of the annual contract value. Putting it in plain language
						revenue was being used interchangeably with the concept of
						“bookings”. But real revenue is not what is booked, but what is
						actually “billed” (invoiced to the customer post implementation) and
						paid within a predictable time period (ideally 30 days or less).
						Everyone, including startups and investors lost track of the
						so-called cash cycle during the “flying pig pandemic ZIRP heydays”.
						Implementation cycles for many high-flying unicorns were (and still
						are) 6-12 months or even longer. Which basically means that if the
						CARR is growing at 100%, there will likely be a 12-month lag between
						CARR and the gap between booked (contract signed) and billed
						(Implementation completed) revenue continues to widen. That billing
						to booking ratio could be 2.0-3.0 or more. Which basically means
						that a $100M CARR company is actually generating $30-50M in actual
						recognized and hopefully collected revenue. The age old of concept
						of cash seemed to disappear. In the quest for CARR (being positioned
						as actual revenue), some companies and investors also lost track of
						ballooning Accounts Receivable, worrying less about whether
						customers were actually paying, but more about how quickly to grow
						the CARR and get a crazy multiple in terms of next round valuation.
						In the frenzy of growing at all costs, many companies resorted to
						becoming solutions engineering companies throwing bodies at the
						problem and custom deployments rather than being truly “product
						led”. Growth, interestingly also got measured by some in terms of
						head count increase, not just CARR. “We grew our team 200% over last
						year” somehow became a metric. Those vanity metrics are now a thing
						of the past!
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" py="16px">
						While an adjustment like post dot-com era, post GFC, and post ZIRP
						years do cause stress in the system, companies that were (and are)
						solving real customer problems and have viable business metrics and
						unit economics (high gross margin, reducing customer acquisition
						costs, high net retention, reducing burn ratio etc.) will do just
						fine. These companies will likely benefit in a funding constraint
						environment as capital chases high quality startups. Entrepreneurs
						have to remember that there is still plenty of capital available,
						but the goal posts are very different with a dual focus on growth
						and profitability (or at least line of sight to profitability). As
						long as there are real sustainable differentiated businesses, there
						is capital available. Having said that, there will be plenty of
						casualties as there always are during a downward funding cycle.
						Finally, remember, that great companies are built during so-called
						funding winters or slowdowns, as gritty entrepreneurs figure out how
						to do more with less and create efficiencies that create high
						growth, profitable ventures.
					</Text>
				</Box>
			</Box>
			<Text
				variant="blogAnswer"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
				fontWeight="500"
			>
				<Text as="span" fontWeight="700" fontStyle="normal">
					#TheContext by IVCA
				</Text>{" "}
				– features opinion makers from the alternate investing industry with
				strong focus on India as an investment destination. Watch this space for
				new announcements in the sector, viewpoints on investment themes,
				emerging trends, economic reports, analysis and latest industry
				insights.
			</Text>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				The content in this section is curated by Team IVCA. For any feedback,
				connect with&nbsp;
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default TheContextPaperAndPlastic;
